export const DashboardsRoutes = [
    {
        "url": "/enterprise-dashboards",
        "name": "appLayout.harriSH.dashboards",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "component": "dashboardsPageContainer",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Enterprise Dashboards"
            }
        ],
    },
    {
        "url": "/employee-voice?from_date&to_date&redirect&tree_id",
        "name": "appLayout.harriSH.dashboards.sentiment-engagement",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "content": {
                "component": "sentimentEngagementComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Sentiment engagement dashboard"
            }
        ],
    },
    {
        "url": "/other-engagement-dashboard",
        "name": "appLayout.harriSH.dashboards.other-engagement",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "content": {
                "component": "otherEngagementComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Other engagement dashboard"
            }
        ],
    },
    {
        "url": "/risk-dashboard?from_date&to_date&tree_id",
        "name": "appLayout.harriSH.dashboards.risk",
        "type": "frontend",
        "loginRequired": true,
        "stopBrandSwitchRedirect": true,
        "views": {
            "content": {
                "component": "riskDashboardComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Risk Analysis"
            }
        ],
        "onEnter": ['$state', 'hUser', 'dashboardsPrerequisiteService', 'brandServices', async function ($state, hUser, dashboardsPrerequisiteService) {
                const entryBrandId = hUser.getEntryMode().brand_id;
                const canViewRiskDashboard = await dashboardsPrerequisiteService.canViewRiskDashboard(entryBrandId);
                if (!canViewRiskDashboard) {
                    $state.go('appLayout.harriSH.dashboard');
                }
            }],
    },
    {
        "url": "/advanced-onboarding-overview-dashboard",
        "name": "appLayout.harriSH.dashboards.advanced-onboarding-overview",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "content": {
                "component": "advancedOnboardingOverviewComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Advanced onboarding dashboard"
            }
        ],
    },
    {
        "url": "/gp-main-dashboard?date",
        "name": "appLayout.harriSH.dashboards.main-gp",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "content": {
                "component": "haloDashboardComponent"
            }
        },
        "stopBrandSwitchRedirect": true,
        "resolve": {
            clearUserContext: ['hUser', async (hUser) => {
                    hUser.clearUserContext();
                    return true;
                }],
        },
        "onEnter": ['hUser', 'userPreferencesManagerService', '$state', 'dashboardsPrerequisiteService', async function (hUser, userPreferencesManagerService, $state, dashboardsPrerequisiteService) {
                const entryBrandId = hUser.getEntryMode().brand_id;
                const canViewHaloDashboard = await dashboardsPrerequisiteService.canViewHaloDashboard(entryBrandId);
                if (!canViewHaloDashboard) {
                    const homePageRoute = await userPreferencesManagerService.getDashboardRoute();
                    if (homePageRoute.isUrl || homePageRoute.redirectToWorkspace) {
                        window.location.href = homePageRoute.href;
                    }
                    else {
                        $state.go(homePageRoute.name, homePageRoute.params);
                    }
                    return;
                }
            }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hmap/hmap.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards', 'save_views'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dynamic Landing Page"
            }
        ],
    },
    {
        "url": "/dashboard/hiring?brand",
        "name": "appLayout.harriSH.dashboard-hiring",
        "type": "frontend",
        "loginRequired": true,
        "params": {
            brand: null
        },
        "component": "hiringDashboardPage",
        "route_dependencies": [],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Hiring Dashboard"
            }
        ],
    },
    {
        "url": "/parent-main-dashboard?date",
        "name": "appLayout.harriSH.dashboards.main-parent",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "content": {
                "component": "haloDashboardComponent"
            }
        },
        "stopBrandSwitchRedirect": true,
        "onEnter": ['hUser', '$state', 'userPreferencesManagerService', 'dashboardsPrerequisiteService', async function (hUser, $state, userPreferencesManagerService, dashboardsPrerequisiteService) {
                if (hUser.isTopLevelContext()) {
                    $state.go('appLayout.harriSH.dashboards.main-gp');
                    return;
                }
                const entryBrandId = hUser.getEntryMode().brand_id;
                const canViewHaloDashboard = await dashboardsPrerequisiteService.canViewHaloDashboard(entryBrandId);
                if (!canViewHaloDashboard) {
                    const homePageRoute = await userPreferencesManagerService.getDashboardRoute();
                    if (homePageRoute.isUrl || homePageRoute.redirectToWorkspace) {
                        window.location.href = homePageRoute.href;
                    }
                    else {
                        $state.go(homePageRoute.name, homePageRoute.params);
                    }
                }
            }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards', 'save_views'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dynamic Landing Page"
            }
        ],
    },
    {
        "url": "/compaas-dashboard",
        "name": "appLayout.harriSH.dashboards.compaas",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "content": {
                "component": "compaasContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "onEnter": ['$state', 'hUser', 'dashboardsPrerequisiteService', function ($state, hUser, dashboardsPrerequisiteService) {
                return new Promise(async (resolve, reject) => {
                    const canViewCompaasDashboard = await dashboardsPrerequisiteService.canViewCompaasDashboard(hUser.getActiveBrandIdWithAccess());
                    if (canViewCompaasDashboard) {
                        resolve();
                    }
                    else {
                        reject();
                        $state.go('appLayout.harriSH.dashboard');
                    }
                });
            }],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | COMPaaS Dashboard"
            }
        ],
    },
    {
        "url": "/tl-compaas-dashboard",
        "name": "appLayout.schedule.tl-compaas-dashboard",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "body": {
                "component": "tlCompaasContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "onEnter": ['$state', 'hUser', 'dashboardsPrerequisiteService', 'TeamScheduleService', function ($state, hUser, dashboardsPrerequisiteService, TeamScheduleService) {
                return new Promise(async (resolve, reject) => {
                    const activeBrand = await TeamScheduleService.getActiveBrand();
                    const canViewCompaasDashboard = await dashboardsPrerequisiteService.canViewCompaasDashboard(activeBrand.id);
                    if (canViewCompaasDashboard) {
                        resolve();
                    }
                    else {
                        reject();
                        $state.go('appLayout.schedule.main');
                    }
                });
            }],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | COMPaaS Dashboard"
            }
        ],
    },
    {
        "url": "/tl-risk-dashboard?from_date&to_date",
        "name": "appLayout.schedule.tl-dashboards-risk",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "body": {
                "component": "tlRiskDashboardComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/dashboards/dashboards.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['dashboards'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Risk Analysis"
            }
        ],
        "onEnter": ['$state', 'hUser', 'dashboardsPrerequisiteService', 'TeamScheduleService', async function ($state, hUser, dashboardsPrerequisiteService, TeamScheduleService) {
                const activeBrand = await TeamScheduleService.getActiveBrand();
                const canViewRiskDashboard = await dashboardsPrerequisiteService.canViewRiskDashboard(activeBrand.id);
                if (!canViewRiskDashboard) {
                    $state.go('appLayout.schedule.main');
                }
            }],
    },
    // Keep original routes for backward compatibility with redirects
];
//# sourceMappingURL=dashboards.routes.js.map